export const EXPLORE_MENU = {
  headingLine1: 'Explore this week’s menu',
  altText: 'Malaysian turmeric chicken with pickled cucumber salad and rice.',
  ctaText: 'Check out this week’s menu',
}
